import { render } from "./AmoivaiaCalculator.vue?vue&type=template&id=225817dc"
import script from "./AmoivaiaCalculator.vue?vue&type=script&lang=js"
export * from "./AmoivaiaCalculator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/AmoivaiaCalculator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "225817dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('225817dc', __exports__)) {
    api.reload('225817dc', __exports__)
  }
  
  module.hot.accept("./AmoivaiaCalculator.vue?vue&type=template&id=225817dc", () => {
    api.rerender('225817dc', render)
  })

}


export default __exports__